const waveAnimation = (): void => {
  let waveImgWidth: number = 0;

  const wave1: HTMLElement | null = document.querySelector('.p-mv__wave1');
  const wave2: HTMLElement | null = document.querySelector('.p-mv__wave2');

  if (wave1) {
    const wave1Img1: HTMLElement | null = wave1?.querySelector('img:nth-child(1)');
    waveImgWidth = wave1Img1?.clientWidth || 0;

    addEventListener('resize', () => {
      waveImgWidth = wave1Img1?.clientWidth || 0;
    });

    const wave1Animation = (translateX: number): void => {
      setTimeout(() => {
        if (wave1) {
          if (translateX >= waveImgWidth) {
            translateX = 100;
          }
          wave1.style.transform = `translateX(-${translateX}px)`;
          translateX = translateX + 0.7;
          wave1Animation(translateX);
        }
      }, 1);
    };
    wave1Animation(100);
  }

  if (wave2) {
    const wave2Img1: HTMLElement | null = wave2?.querySelector('img:nth-child(1)');
    waveImgWidth = wave2Img1?.clientWidth || 0;

    addEventListener('resize', () => {
      waveImgWidth = wave2Img1?.clientWidth || 0;
    });

    const wave2Animation = (translateX: number): void => {
      setTimeout(() => {
        if (wave2) {
          if (translateX >= waveImgWidth) {
            translateX = 100;
          }
          wave2.style.transform = `translateX(-${translateX}px)`;
          translateX = translateX + 0.3;
          wave2Animation(translateX);
        }
      }, 1);
    };
    wave2Animation(100);
  }
};

export default waveAnimation;
